import React from "react";
import { Link } from "react-router-dom";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV === "development") {
      console.error("ErrorBoundary caught:", error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
          <div className="text-center max-w-md">
            <h1 className="text-4xl font-bold text-custom-pink mb-4">Something went wrong</h1>
            <p className="text-gray-600 mb-6">We apologise for the inconvenience. Please try refreshing the page or return home.</p>
            <div className="flex gap-4 justify-center">
              <button
                onClick={() => window.location.reload()}
                className="px-6 py-3 rounded-lg bg-custom-pink text-white hover:bg-purple-700 transition"
              >
                Refresh Page
              </button>
              <Link
                to="/"
                className="px-6 py-3 rounded-lg border-2 border-custom-pink text-custom-pink hover:bg-custom-pink hover:text-white transition"
              >
                Go Home
              </Link>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
